
//   爱逛好店
export default [{
    path: '/newProductLaunch',
    name: 'newProductLaunch',
    meta: {
      index: 2
    },
    component: () => import('@/views/newProductLaunch/index')
  }]
  